export default "__VITE_ASSET__BCQsUxqk__"